export default __webpack_public_path__ + "static/media/sander-min.ad54080f.png";